(function(){
  if (window.__wlInsuranceInit) return;
  window.__wlInsuranceInit = true;
  var wlInsurancePending = false;

  function wlInsuranceRender(vid, quantity) {
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function(el){ return el.dataset.sectionId; }).filter(Boolean);
    var body = { id: vid, quantity: quantity, sections: sectionIds.join(','), sections_url: window.location.pathname };
    return fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(data){
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource: data, sourceId: 'wl-insurance', data: { source: 'wl-insurance', sections: data.sections } } }));
      });
  }

  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-wl-insurance-toggle]')) return;
    var box = t.closest('[data-wl-insurance]');
    if (!box) return;
    var vid = box.getAttribute('data-wl-insurance-vid');
    if (!vid) return;
    if (wlInsurancePending) { t.checked = !t.checked; return; }
    wlInsurancePending = true;
    box.classList.add('wl-insurance--loading');
    var checked = t.checked;
    var url = checked ? '/cart/add.js' : '/cart/change.js';
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function(el){ return el.dataset.sectionId; }).filter(Boolean);
    var body = checked
      ? { items: [{ id: vid, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }
      : { id: vid, quantity: 0, sections: sectionIds.join(','), sections_url: window.location.pathname };
    fetch(url, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){
        if (!r.ok) { return r.json().then(function(data){ throw new Error((data && data.description) || 'cart request failed'); }); }
        return r.json();
      })
      .then(function(data){
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource: data, sourceId: 'wl-insurance', data: { source: 'wl-insurance', sections: data.sections } } }));
        // Re-sync shortly after: if this toggle landed right after another cart action (e.g. just added
        // the first product), that action's own re-render can resolve later and clobber this one with
        // stale totals. A second, idempotent render pass wins the race and guarantees the display is correct.
        setTimeout(function(){ wlInsuranceRender(vid, checked ? 1 : 0); }, 600);
      })
      .catch(function(err){ console.error(err); t.checked = !checked; })
      .finally(function(){ wlInsurancePending = false; box.classList.remove('wl-insurance--loading'); });
  });
})();
